import * as React from "react";
import { Route, Link, Switch, useLocation } from "react-router-dom";

import { Layout, Menu } from "antd";
import {
  FormOutlined,
  BulbOutlined,
  HomeOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

// utils
import { mapUrlToName, setTitle } from "./components/common/util";

// components
import HomePage from "./components/Home";
import LecturePage from "./components/Lecture";
import TestPage from "./components/Test";
import AboutPage from "./components/About";
import NotFoundPage from "./components/NotFound";

// styles
import "./App.css";

const App = () => {
  const location = useLocation();
  const [key, setKey] = React.useState<string>("home");

  React.useEffect(() => {
    const url = location.pathname.split("/")[1].replace(/\//g, "");
    setKey(url || "home");
    setTitle(mapUrlToName(url));
  }, [location]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout.Sider
        breakpoint="lg"
        collapsedWidth="0"
        style={{
          zIndex: 20,
        }}
      >
        <div className="logo" />
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["home"]}
          activeKey={key}
          selectedKeys={[key]}
        >
          <Menu.Item key="logo" disabled style={{ marginLeft: 24 }}>
            <b className="logo">CyTrain</b>
          </Menu.Item>
          <Menu.Item key="home" icon={<HomeOutlined />}>
            <Link to="/">ホーム</Link>
          </Menu.Item>
          <Menu.Item key="lectures" icon={<FormOutlined />}>
            <Link to="/lectures">講座</Link>
          </Menu.Item>
          <Menu.Item key="tests" icon={<BulbOutlined />}>
            <Link to="/tests">確認テスト</Link>
          </Menu.Item>
          <Menu.Item key="about" icon={<InfoCircleOutlined />}>
            <Link to="/about">このサイトについて</Link>
          </Menu.Item>
        </Menu>
      </Layout.Sider>
      <Layout>
        <Layout.Content>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/about" component={AboutPage} />
            <Route path="/lectures" component={LecturePage} />
            <Route path="/tests" component={TestPage} />
            <Route component={NotFoundPage} />
          </Switch>
        </Layout.Content>
        <Layout.Footer style={{ textAlign: "center" }}>
          ©2021 CyTrain by shyamajp
        </Layout.Footer>
      </Layout>
    </Layout>
  );
};

export default App;
